<!-- CONFIRM EDIT BUSY SLOT MODAL -->
<office-modal [isOpen]="open">
	<office-modal-container
		*ngIf="open"
		[transparent]="true"
		[footerBorder]="true"
	>
		<!-- Header -->
		<div class="confirm-action-busy-slot--header" header>
			<div class="zk-flex zk-justify-between zk-gap-2 zk-items-center">
				<div class="confirm-action-busy-slot--title zk-flex zk-gap-3">
					<h1 style="
						font-family: var(--asset-font-sourcesanspro-name), sans-serif;
						font-size: var(--font-size-xl);
						font-style: normal;
						font-weight: 700;
						line-height: 24px;
						letter-spacing: 0em;
						text-align: left;
						color: #212529;
					">
						{{'GENERAL.EDIT_RECURRENCY_EVENT' | translate}}
					</h1>
				</div>
			</div>
		</div>

		<!-- Body -->
		<section
			id="calendar-sidebar"
			class="confirm-action-busy-slot"
			body
		>
			<div class="options-container">
				<div class="zk-flex zk-gap-2 radio-item">
					<freud-radio-button
						[(ngModel)]="selectedOption"
						[label]="'GENERAL.THIS_EVENT' | translate"
						[name]="'confirm-action-busy-slot'"
						[radioValue]="'only'"
						(valueChange)="setOption('only')"
					></freud-radio-button>
				</div>
				<div class="radio-item">
					<freud-radio-button
						[(ngModel)]="selectedOption"
						[name]="'confirm-action-busy-slot'"
						[label]="'GENERAL.THIS_AND_FUTURE_EVENTS' | translate"
						[radioValue]="'future'"
						(valueChange)="setOption('future')"
					></freud-radio-button>
				</div>
				<div class="radio-item">
					<freud-radio-button
						[(ngModel)]="selectedOption"
						[name]="'confirm-action-busy-slot'"
						[label]="'GENERAL.ALL_EVENTS' | translate"
						[radioValue]="'all'"
						(valueChange)="setOption('all')"
					></freud-radio-button>
				</div>
			</div>
		</section>

		<!-- Footer -->
		<section
			footer
			style="
				align-items: center;
				display: flex;
				justify-content: flex-end;
				flex-direction: column;
			"
		>
			<!-- Actions. -->
			<div class="apDetails-actions" id="apDetails-actions">
				<div class="zk-flex zk-gap-2">
					<freud-button
						(click)="close()"
						[color]="'secondary'"
					>
						{{ 'OPERATIONS.CANCEL' | translate }}
					</freud-button>
					<freud-button
						(click)="confirm()"
					>
						{{ 'OPERATIONS.CONFIRM' | translate }}
					</freud-button>
				</div>
			</div>
		</section>
	</office-modal-container>
</office-modal>
